import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=29027ab6&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import "./Records.vue?vue&type=style&index=0&id=29027ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29027ab6",
  null
  
)

export default component.exports